import pick from 'lodash/pick';
import type { IStringifyOptions } from 'qs';

import { LIST_TYPES } from 'Utilities/consts';
import { allowedVehicleStatesByFilter } from 'Utilities/vehicleState';

export const RESULTS_PER_PAGE = 36;
export const TEST_VEHICLE_ID = 30469;
export const QUERY_STRING_OPTIONS: IStringifyOptions = { allowDots: true, arrayFormat: 'repeat' };

export const ALLOWED_PROXY_HEADERS = ['x-mway-providers-versions', 'x-mway-use-search'];
export const MAKE_MODEL_COUNT_STATES = [
	LIST_TYPES.auction,
	LIST_TYPES.buyItNow,
	LIST_TYPES.shortlist,
	LIST_TYPES.aiCompanion,
];

export const MOTORWAY_PROVIDERS = {
	MOTORWAY_BIDDING: 'motorway-bidding',
	MW_CUSTOMER_SUPPORT: 'motorway-customer-support',
	MW_DEALER_CORE: 'mw-dealer-core',
	MW_DEALER_OTP: 'mw-dealer-otp',
	MW_DEALERSHIP_COMPOSER: 'mw-dealership-composer',
	MW_DEALERSHIP_PLATFORM: 'motorway-dealership-platform',
	MW_HTML_FOR_PDF: 'mw-html-for-pdf',
	MW_PAYMENTS: 'mw-payments',
	MW_PDF: 'mw-pdf',
	MW_SERVICE_HISTORY: 'mw-service-history',
	MW_TRANSACTION_CORE: 'mw-transaction-core',
	MW_VEHICLE_CORE: 'mw-vehicle-core',
};

export const DEFAULT_MODELS_QUERY = 'skipModelsWithoutVehicles=true&displayAllModels=false';

export const ALLOWED_STATES_FOR_MAKE_MODEL_COUNT = pick(allowedVehicleStatesByFilter, MAKE_MODEL_COUNT_STATES);

export const FEATURE_FLAG_SCOPES = { dealer: 'dealer', dealership: 'dealership' } as const;

// LD feature flags will not work for unauthenticated users. The endpoint is currently restricted.
export const BE_TO_FE_FEATURE_FLAGS_MAP = {
	BULK_BIDDING_CSV: { feToggleName: 'bulkBiddingCsv', scope: FEATURE_FLAG_SCOPES.dealer },
	EX_LEASE_BRANDING: { feToggleName: 'exLeaseBranding', scope: FEATURE_FLAG_SCOPES.dealer },
	FORCE_REFRESH_ON_OUT_OF_SYNC_BUILD: {
		feToggleName: 'forceRefreshOnOutOfSyncBuild',
		scope: FEATURE_FLAG_SCOPES.dealer,
	},
	FORCE_VEHICLE_LIST_ERROR_SCREEN: {
		feToggleName: 'forceVehicleListErrorScreen',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	INSIGHTS: { feToggleName: 'insights', scope: FEATURE_FLAG_SCOPES.dealership },
	KYC_FREEZE: { feToggleName: 'kycFreeze', scope: FEATURE_FLAG_SCOPES.dealership },
	MOBILIZE_MARKETPLACE_VISIBILITY: { feToggleName: 'mobilizeMarketplaceVisibility', scope: FEATURE_FLAG_SCOPES.dealer },
	PARTNER_VEHICLE_VISIBILITY: { feToggleName: 'partnerVehicleVisibility', scope: FEATURE_FLAG_SCOPES.dealer },
	PEN_TESTING_BIDDING: { feToggleName: 'penTestingBidding', scope: FEATURE_FLAG_SCOPES.dealership },
	PROMOTIONS_DISCOUNT_BUY_2_GROUP: {
		feToggleName: 'promotionsDiscountBuy2Group',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	PROMOTIONS_DISCOUNT_BUY_6_GROUP: {
		feToggleName: 'promotionsDiscountBuy6Group',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	PROMOTIONS_DISCOUNT_BUY_11_GROUP: {
		feToggleName: 'promotionsDiscountBuy11Group',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	PROMOTIONS_DISCOUNT_BUY_25_GROUP: {
		feToggleName: 'promotionsDiscountBuy25Group',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	SELLER_COMMUNICATIONS: { feToggleName: 'sellerCommunications', scope: FEATURE_FLAG_SCOPES.dealership },
	SELLER_SERVICE_FEES: { feToggleName: 'sellerServiceFees', scope: FEATURE_FLAG_SCOPES.dealership },
	SHOW_DOWNLOAD_CSV_BUTTON_OUTSIDE_LIST: {
		feToggleName: 'showDownloadCSVButtonOutsideList',
		scope: FEATURE_FLAG_SCOPES.dealership,
	},
	SIMILAR_VEHICLES_MAKE_MODEL: { feToggleName: 'similarVehiclesMakeModel', scope: FEATURE_FLAG_SCOPES.dealer },
	SIMILAR_VEHICLES_V2: { feToggleName: 'similarVehiclesV2', scope: FEATURE_FLAG_SCOPES.dealer },
	TRANSPORT_PROVIDER_USER: { feToggleName: 'estimatedDeliveryCosts', scope: FEATURE_FLAG_SCOPES.dealership },
	VEHICLE_LIST_HERO_IMAGES: { feToggleName: 'vehicleListHeroImages', scope: FEATURE_FLAG_SCOPES.dealership },
} as const;

export const INVERSE_FEATURE_TOGGLES = ['estimatedDeliveryCosts'];

export const SALES_RULES = [
	'isSaleActive',
	'todaysSaleStartedAt',
	'todaysSaleEndsAt',
	'nextSaleStartsAt',
	'saleClosingHour',
	'saleClosingMinute',
	'isLiveSaleEnabled',
];
